module.exports = __webpack_public_path__ + "img/1.b73894d8.png";